export const TABLE_BOOKING_URL = 'https://obee.com.au'

export const restaurantsBreadcrumbSteps = [
  {
    label: 'Grill’d',
    link: '/'
  },
  {
    label: 'Find Restaurant'
  }
]
